import React, {useState} from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Person from './Person';
import './InterviewsTableStyle.css'
import DropItem from "./drop-item";
import DragItem from "./drag-item";


export default function InterviewsTable(interviewsData) {
    const [acquaintancesIds, setAcquaintancesIds] = useState({});
    const [exercisesAcquaintancesIds, setExercisesAcquaintancesIds] = useState(null);
    const [editData, setEditData] = useState({});

    const currentSessions = interviewsData.interviewsData.classes;
    const inputChosenCategories = interviewsData.inputChosenCategories;
    const interviewTimes = interviewsData.interviewsData.times;
    const sessionsId = interviewsData.interviewsData.sessionsId;

    const callbackShowToast = () => {
        interviewsData.callbackShowToast();
    };

    const callbackShowErrorToast = () => {
        setAcquaintancesIds(null);
        setExercisesAcquaintancesIds(null);
        interviewsData.callbackShowErrorToast();
    };

    const callbackShowMessageToast = (toastMessage) => {
        interviewsData.callbackShowMessageToast(toastMessage);
    }

    const highlightAcquaintances = (updatedAcquaintances, updatedAcquaintancesExercises) => {
        const highlightPersons = {};
        // true for regular acquaintancesIds
        updatedAcquaintances.forEach(person => highlightPersons[person.id] = true);
        updatedAcquaintancesExercises.forEach(person => highlightPersons[person.id] = false);
        setAcquaintancesIds(highlightPersons);
        // const timer = setTimeout(() => {
        //     setAcquaintancesIds({});
        //     console.log(acquaintancesIds);
        //     debugger;
        // }, 3000);
        // return () => clearTimeout(timer);
    };

    const highlightExercisesAcquaintances = (updatedExercisesAcquaintancesIds) => {
        setExercisesAcquaintancesIds(updatedExercisesAcquaintancesIds);
    };

    // Return false if every filter menu is with none value, otherwise return true. With this function we calc
    // only once if something should be highlighted (instead of calc this in every person rendering)
    const calcHasFilter = () => {
        if (inputChosenCategories) {
            for (let i = 0; i < Object.keys(inputChosenCategories).length; i++) {
                // there is only one key which is the category name.
                // debugger;
                const category = Object.keys(inputChosenCategories)[i];
                if (inputChosenCategories[category] !== 'none') {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    };

    return (
        <TableContainer className="tableInterviewsContainer" component={Paper} dir="rtl">

            <Table className="TableScrolling" aria-label="custom pagination table">
                <TableHead dir="rtl">
                    <TableRow>
                        <TableCell className="EmptyCell"></TableCell>
                        {(currentSessions
                        ).map((row, i) => {
                            if (i === 0) {
                                return <TableCell align="right" key={i} className="personsTitle">
                                    <div className="personsTitle">מעריכים</div>
                                </TableCell>
                            } else {
                                return <TableCell key={i} className="EmptyCell"></TableCell>
                            }
                        })}
                    </TableRow>
                    <TableRow>
                        <TableCell className="InterviewTableHeaderCell"></TableCell>
                        {(currentSessions
                        ).map((row, i) => (
                            // eslint-disable-next-line
                            <TableCell key={i} align="right" className="InterviewTableHeaderCell">
                                <DropItem onDrop={id => {
                                    setEditData({personId: id, desiredClass: row.id, reviewerPosition: true})
                                    // setEditedPersonId(null);
                                }}>
                                    <div className="InterviewsHeader">
                                        <div className="Class">
                                            כיתה {row.id}
                                        </div>
                                        <DragItem data=<Person key={row.reviewers[0].id}
                                                  person={row.reviewers[0]}
                                                  chosenCategories={inputChosenCategories}
                                                  hasFilter={calcHasFilter(inputChosenCategories)}
                                                  acquaintancesCallback={highlightAcquaintances}
                                                  acquaintancesIds={acquaintancesIds}
                                                  exercisesAcquaintancesCallback={highlightExercisesAcquaintances}
                                                  exercisesAcquaintancesIds={exercisesAcquaintancesIds}
                                                  isInterviewPage={true}
                                                  intreviewsHours={interviewTimes}
                                                  sessionsId={sessionsId}
                                                  classId={row.id}
                                                  isReviewer={true}
                                                  callbackShowToast={callbackShowToast}
                                                  callbackShowErrorToast={callbackShowErrorToast}
                                                  callbackShowMessageToast={callbackShowMessageToast}
                                                  editData={editData}/>id={row.reviewers[0].id}
                                        key={row.reviewers[0].id} />
                                        <DragItem data=<Person key={row.reviewers[1].id} person={row.reviewers[1]}
                                                  chosenCategories={inputChosenCategories}
                                                  hasFilter={calcHasFilter(inputChosenCategories)}
                                                  acquaintancesCallback={highlightAcquaintances}
                                                  acquaintancesIds={acquaintancesIds}
                                                  exercisesAcquaintancesCallback={highlightExercisesAcquaintances}
                                                  exercisesAcquaintancesIds={exercisesAcquaintancesIds}
                                                  isInterviewPage={true}
                                                  intreviewsHours={interviewTimes}
                                                  classId={row.id}
                                                  sessionsId={sessionsId}
                                                  isReviewer={true}
                                                  callbackShowToast={callbackShowToast}
                                                  callbackShowErrorToast={callbackShowErrorToast}
                                                  callbackShowMessageToast={callbackShowMessageToast}
                                                  editData={editData}/>id={row.reviewers[1].id}
                                        key={row.reviewers[1].id} />
                                    </div>
                                </DropItem>
                            </TableCell>
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell className="EmptyCell"></TableCell>
                        {(currentSessions
                        ).map((row, i) => {
                            if (i === 0) {
                                return <TableCell align="right" key={i} className="personsTitle">
                                    <div className="personsTitle">מועמדים</div>
                                </TableCell>
                            } else {
                                return <TableCell key={i} className="EmptyCell"></TableCell>
                            }
                        })}
                    </TableRow>
                </TableHead>
                <TableBody dir="rtl">
                    <TableRow>
                        <TableCell align="right" className="TimeCell" component="th" scope="row">
                            {interviewTimes[0]}
                        </TableCell>
                        {(currentSessions
                        ).map((row, i) => (
                            row.interviews[interviewTimes[0]] ?
                                <TableCell align="right"
                                           className={(i === currentSessions.length - 1) ? "InterviewTableCellLastItem" : "InterviewTableCell"}
                                           key={i}>
                                    <DropItem onDrop={id => {
                                        setEditData({
                                            personId: id,
                                            desiredClass: row.id,
                                            reviewerPosition: false,
                                            isFirst: 1
                                        })
                                        // setEditedPersonId(null);
                                    }}>
                                        <div className="PersonCell">
                                            <DragItem data=<Person key={row.interviews[interviewTimes[0]].id}
                                                      person={row.interviews[interviewTimes[0]]}
                                                      chosenCategories={inputChosenCategories}
                                                      hasFilter={calcHasFilter(inputChosenCategories)}
                                                      acquaintancesCallback={highlightAcquaintances}
                                                      acquaintancesIds={acquaintancesIds}
                                                      exercisesAcquaintancesCallback={highlightExercisesAcquaintances}
                                                      exercisesAcquaintancesIds={exercisesAcquaintancesIds}
                                                      classId={row.id}
                                                      isInterviewPage={true}
                                                      intreviewsHours={interviewTimes}
                                                      sessionsId={sessionsId}
                                                      isReviewer={false}
                                                      callbackShowToast={callbackShowToast}
                                                      callbackShowErrorToast={callbackShowErrorToast}
                                                      callbackShowMessageToast={callbackShowMessageToast}
                                                      isFirst={1}
                                                      editData={editData}/>id={row.interviews[interviewTimes[0]].id}
                                            key={row.interviews[interviewTimes[0]].id} />
                                        </div>
                                    </DropItem>
                                </TableCell>
                                : <TableCell
                                    key={i} className={(i === currentSessions.length - 1) ? "InterviewTableCellLastItem" : "InterviewTableCell"}>
                                    <DropItem onDrop={id => {
                                        setEditData({
                                            personId: id,
                                            desiredClass: row.id,
                                            reviewerPosition: false,
                                            isFirst: 1
                                        })
                                        // setEditedPersonId(null);
                                    }}>
                                        <div className="PersonCell" style={{height: "32px"}}>
                                            <DragItem id={0}
                                                      key={0}/>
                                        </div>
                                    </DropItem></TableCell>
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell className="EmptyCell"></TableCell>
                        {(currentSessions
                        ).map((row,i) => (
                            <TableCell key={i} className="EmptyCell"></TableCell>
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell align="right" className="TimeCell" component="th" scope="row">
                            {interviewTimes[1]}
                        </TableCell>
                        {(currentSessions
                        ).map((row, i) =>
                            row.interviews[interviewTimes[1]] ?
                                <TableCell align="right"
                                           className={(i === currentSessions.length - 1) ? "InterviewTableCellLastItem" : "InterviewTableCell"}
                                           key={i}>
                                    <DropItem onDrop={id => {
                                        setEditData({
                                            personId: id,
                                            desiredClass: row.id,
                                            reviewerPosition: false,
                                            isFirst: 0
                                        })
                                        // setEditedPersonId(null);
                                    }}>
                                        <div className="PersonCell">
                                            <DragItem data=<Person key={row.interviews[interviewTimes[1]].id}
                                                      person={row.interviews[interviewTimes[1]]}
                                                      chosenCategories={inputChosenCategories}
                                                      hasFilter={calcHasFilter(inputChosenCategories)}
                                                      acquaintancesCallback={highlightAcquaintances}
                                                      acquaintancesIds={acquaintancesIds}
                                                      exercisesAcquaintancesCallback={highlightExercisesAcquaintances}
                                                      exercisesAcquaintancesIds={exercisesAcquaintancesIds}
                                                      classId={row.id}
                                                      isInterviewPage={true}
                                                      intreviewsHours={interviewTimes}
                                                      sessionsId={sessionsId}
                                                      isReviewer={false}
                                                      callbackShowToast={callbackShowToast}
                                                      callbackShowErrorToast={callbackShowErrorToast}
                                                      callbackShowMessageToast={callbackShowMessageToast}
                                                      isFirst={0}
                                                      editData={editData}/>id={row.interviews[interviewTimes[1]].id}
                                            key={row.interviews[interviewTimes[1]].id} />
                                        </div>
                                    </DropItem>
                                </TableCell>
                                : <TableCell
                                    className={(i === currentSessions.length - 1) ? "InterviewTableCellLastItem" : "InterviewTableCell"}>
                                    <DropItem onDrop={id => {
                                        setEditData({
                                            personId: id,
                                            desiredClass: row.id,
                                            reviewerPosition: false,
                                            isFirst: 0
                                        })
                                        // setEditedPersonId(null);
                                    }}>
                                        <div className="PersonCell" style={{height: "32px"}}>
                                            <DragItem id={0}
                                                      key={0}/>
                                        </div>
                                    </DropItem>
                                </TableCell>
                        )}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
